<template>
  <div class="solo_cmp">
    <Menu />
    <div class="schead">
      <img
        class="icon_left"
        @click="back"
        src="~@/assets/pricing2/solo/bleft@2x.png"
        alt=""
      />
      <span class="head_text">套餐对比</span>
      <img
        class="icon_right"
        @click="close"
        src="~@/assets/pricing2/solo/bclose@2x.png"
        alt=""
      />
    </div>
    <div class="tab_bx">
      <div
        class="titem"
        @click="active_tab = index"
        :class="{ active: index == active_tab }"
        v-for="(item, index) in tabs"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <!-- 基础版 -->
    <div class="data_bx base_bx" v-if="active_tab == 0">
      <div class="btitle">仅个人使用</div>
      <div class="dlist_items">
        <div
          class="di_item"
          v-for="(item, index) in blist"
          :key="index"
          :class="`di_item${item.text ? item.text.length : 0}`"
        >
          <p class="di_item_title" :style="{ color: item.textColor }">
            {{ item.desc }}
            <span v-if="item.xmIcon" class="xmIcon">限免</span>
            <Tooltip v-if="item.toolTip" effect="dark" placement="top" popper-class="common-tool-tip">
              <p slot="content">{{ item.content }}</p>
              <span class="icon_wrap"></span>
            </Tooltip>
          </p>
          <div class="di_item_desc">
            <img
              class="icon_left"
              v-if="item.iconL"
              :src="require(`@/assets/pricing2/solo/${item.iconL}`)"
              alt=""
            />
            <template v-if="item.star">
              <img
                class="di_item_star"
                v-for="i of item.star"
                :key="i"
                src="@/assets/pricing2/solo/bstar@2x.png"
                alt=""
              />
            </template>
            <div class="di_item_text" v-if="item.text && item.text.length > 0">
              <p
                v-for="(ditem, dindex) in item.text"
                :key="dindex"
                :style="{ color: item.textColor }"
              >
                {{ ditem }}
              </p>
            </div>
            <img
              class="di_item_check"
              v-if="item.check"
              src="@/assets/pricing2/solo/bcheck@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="dboo">
        <router-link class="boo_btn" to="/download">立即下载</router-link>
      </div>
    </div>
    <!-- 专业版 -->
    <div class="data_bx pro_bx" v-if="active_tab == 1">
      <div class="btitle">低延迟、专业级的远控体验</div>
      <div class="dlist_items">
        <div
          class="di_item"
          v-for="(item, index) in plist"
          :key="index"
          :class="`di_item${item.text ? item.text.length : 0}`"
        >
          <p class="di_item_title" :style="{ color: item.textColor }">
            {{ item.desc }}
            <Tooltip v-if="item.toolTip" effect="dark" placement="top" popper-class="common-tool-tip">
              <p slot="content">{{ item.content }}</p>
              <span class="icon_wrap"></span>
            </Tooltip>
          </p>
          <div class="di_item_desc">
            <img
              class="icon_left"
              v-if="item.iconL"
              :src="require(`@/assets/pricing2/solo/${item.iconL}`)"
              alt=""
            />
            <template v-if="item.star">
              <img
                class="di_item_star"
                v-for="i of item.star"
                :key="i"
                src="@/assets/pricing2/solo/pstar@2x.png"
                alt=""
              />
            </template>
            <div class="di_item_text" v-if="item.text && item.text.length > 0">
              <p
                v-for="(ditem, dindex) in item.text"
                :key="dindex"
                :style="{ color: item.textColor }"
              >
                {{ ditem }}
              </p>
            </div>
            <img
              class="di_item_check"
              v-if="item.check"
              src="@/assets/pricing2/solo/pcheck@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="dboo">
        <a class="boo_btn" :href="_uc_mb_hostName">立即使用</a>
      </div>
    </div>
    <!-- 游戏版 -->
    <div class="data_bx game_bx" v-if="active_tab == 2">
      <div class="btitle">畅享高玩体验，快乐无边界</div>
      <div class="dlist_items">
        <div
          :class="['di_item', item.iconGame ? 'di_item_game' : '']"
          v-for="(item, index) in glist"
          :key="index"
        >
          <p class="di_item_title" :style="{ color: item.textColor }">
            {{ item.desc }}
            <Tooltip v-if="item.toolTip" effect="dark" placement="top" popper-class="common-tool-tip">
              <p slot="content">{{ item.content }}</p>
              <span class="icon_wrap"></span>
            </Tooltip>
          </p>
          <!-- 游戏版特殊渲染 -->
          <div class="di_item_desc game_render" v-if="item.iconGame">
            <div
              v-for="gItem in item.render"
              :key="gItem.iconL"
              class="game_render_item"
            >
              <img
                class="icon_left"
                v-if="gItem.iconL"
                :src="require(`@/assets/pricing2/solo/${gItem.iconL}`)"
                alt=""
              />
              <template v-if="gItem.star">
                <img
                  class="di_item_star"
                  v-for="i of gItem.star"
                  :key="i"
                  src="@/assets/pricing2/solo/pstar@2x.png"
                  alt=""
                />
              </template>
              <div
                class="di_item_text"
                v-if="gItem.text && gItem.text.length > 0"
              >
                <p
                  v-for="(ditem, dindex) in gItem.text"
                  :key="dindex"
                  :style="{ color: gItem.textColor }"
                >
                  {{ ditem }}
                </p>
              </div>
              <img
                class="di_item_check"
                v-if="item.check"
                src="@/assets/pricing2/solo/pcheck@2x.png"
                alt=""
              />
            </div>
          </div>
          <div class="di_item_desc" v-else>
            <img
              class="icon_left"
              v-if="item.iconL"
              :src="require(`@/assets/pricing2/solo/${item.iconL}`)"
              alt=""
            />
            <template v-if="item.star">
              <img
                class="di_item_star"
                v-for="i of item.star"
                :key="i"
                src="@/assets/pricing2/solo/star4@2x.png"
                alt=""
              />
            </template>
            <div class="di_item_text" v-if="item.text && item.text.length > 0">
              <p
                v-for="(ditem, dindex) in item.text"
                :key="dindex"
                :style="{ color: item.textColor }"
              >
                {{ ditem }}
              </p>
            </div>
            <img
              class="di_item_check"
              v-if="item.check"
              src="@/assets/pricing2/solo/gcheck@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="dboo">
        <a class="boo_btn" :href="_uc_mb_hostName">立即使用</a>
      </div>
    </div>
    <!-- 性能版 -->
    <div class="data_bx perform_bx" v-if="active_tab == 3">
      <div class="btitle">远程设计创作的极致体验</div>
      <div class="dlist_items">
        <div
          :class="[
            'di_item',
            item.iconGame ? 'di_item_game' : '',
            item.desc === '真彩模式' || item.desc === '数位板' || item.desc === '虚拟屏' || item.desc === '多屏' ? 'di_item_perform' : ''
          ]"
          v-for="(item, index) in performlist"
          :key="index"
        >
          <p class="di_item_title" :style="{ color: item.textColor }">
            {{ item.desc }}
            <Tooltip v-if="item.toolTip" effect="dark" placement="top" popper-class="common-tool-tip">
              <p slot="content">{{ item.content }}</p>
              <span class="icon_wrap"></span>
            </Tooltip>
          </p>
          <!-- 性能版特殊渲染 -->
          <div class="di_item_desc game_render" v-if="item.iconGame">
            <div
              v-for="gItem in item.render"
              :key="gItem.iconL"
              class="game_render_item"
            >
              <img
                class="icon_left"
                v-if="gItem.iconL"
                :src="require(`@/assets/pricing2/solo/${gItem.iconL}`)"
                alt=""
              />
              <template v-if="gItem.star">
                <img
                  class="di_item_star"
                  v-for="i of gItem.star"
                  :key="i"
                  src="@/assets/pricing2/solo/pstar@2x.png"
                  alt=""
                />
              </template>
              <div
                class="di_item_text"
                v-if="gItem.text && gItem.text.length > 0"
              >
                <p
                  v-for="(ditem, dindex) in gItem.text"
                  :key="dindex"
                  :style="{ color: gItem.textColor }"
                >
                  {{ ditem }}
                </p>
              </div>
              <img
                class="di_item_check"
                v-if="item.check"
                src="@/assets/pricing2/solo/hcheck@2x.png"
                alt=""
              />
            </div>
          </div>
          <div class="di_item_desc" v-else>
            <img
              class="icon_left"
              v-if="item.iconL"
              :src="require(`@/assets/pricing2/solo/${item.iconL}`)"
              alt=""
            />
            <template v-if="item.star">
              <img
                class="di_item_star"
                v-for="i of item.star"
                :key="i"
                src="@/assets/pricing2/solo/hstar@2x.png"
                alt=""
              />
            </template>
            <div class="di_item_text" v-if="item.text && item.text.length > 0">
              <p
                v-for="(ditem, dindex) in item.text"
                :key="dindex"
                :style="{ color: item.textColor }"

              >
                {{ ditem }}
              </p>
            </div>
            <img
              class="di_item_check"
              v-if="item.check"
              src="@/assets/pricing2/solo/hcheck@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="dboo">
        <a class="boo_btn" :href="_uc_mb_hostName">立即使用</a>
      </div>
    </div>
  </div>
</template>
<script>
import { Tooltip } from 'element-ui'
import Menu from "@/components/menu";
export default {
  components: {
    Tooltip,
    Menu
  },
  data() {
    return {
      tabs: ["个人版", "专业版", "游戏版", "性能版"],
      active_tab: 0,
      // 性能版
      performlist: [
        { desc: "网络", text: ["RTC+VIP专属高速机房通道"] },
        {
          desc: "画质",
          render: [
            { text: ["最高4K60FPS (原画) /"], iconL: "picq_game@2x.png" },
            { text: ["最高2K144FPS(需v4.7.0.1及以上)"], iconL: "2K@2x.png" },
          ],
          iconGame: true,
        },
        { desc: "鼠标加速通道", text: ["最高120hz"], star: 5 },
        { desc: "远控服务", text: ["不限"]},
        // { desc: "设备列表", text: ["100"] },
        { desc: "PC端文件传输", text: ["高速文件服务器"], star: 5 },
        { desc: "安卓被控	", text: ["1个"]},
        { desc: "共享剪贴板", check: true },
        { desc: "远程开机", check: true },
        { desc: "锁屏", check: true },
        { desc: "观看模式", check: true },
        { desc: "文字聊天", check: true },
        { desc: "音频传输", check: true },
        { desc: "锁定鼠标", check: true },
        { desc: "远程鼠标", check: true },
        { desc: "重启", check: true },
        { desc: "关机", check: true },

        { desc: "终端工具", check: true },
        { desc: "禁用被控键鼠", check: true },
        { desc: "远程摄像头", check: true },
        { desc: "隐私屏", check: true },
        { desc: "3D鼠标", check: true },
        { desc: "远程打印", check: true },
        { desc: "扩展屏和镜像屏", xmIcon: true, check: true },
        { desc: "摄像头", xmIcon: true, check: true },
        { desc: "麦克风", xmIcon: true, check: true },

        { desc: "组合按键", check: true },
        { desc: "游戏鼠标", text: ["支持Windows4.7.1及以上版本使用"] },
        { desc: "游戏键盘", text: ["支持Android、iOS端"] },
        { desc: "游戏手柄", text: ["支持在Windows使用PS、", "Xbox游戏手柄"] },

        { desc: "真彩模式", toolTip: true, content: '被控设备需支持NVIDIA独立显卡，显卡版本不够时需升级显卡驱动；被控为Mac、Linux时暂不支持开启真彩模式；v4.6.0以下版本暂不支持使用', check: true },
        { desc: "数位板",  toolTip: true, content: '暂不支持v4.6.0以下版本或被控为Mac、Linux系统或Windows10以下系统时使用', check: true },
        { desc: "虚拟屏", toolTip: true, content: 'v4.6.0以下或win10 1903以下系统暂不支持本功能', text: ['支持在被控创建最多3个', '虚拟扩展屏幕'] },
        { desc: "多屏", toolTip: true, content: '暂不支持被控为Linux系统时使用', text: ['支持在主控显示被控的多个屏幕'] },
      ],
      // 游戏版
      glist: [
        { desc: "网络", text: ["RTC+VIP专属高速机房通道"] },
        {
          desc: "画质",
          render: [
            { text: ["最高4K60FPS (原画) /"], iconL: "picq_game@2x.png" },
            { text: ["最高2K144FPS(需v4.7.0.1及以上)"], iconL: "2K@2x.png" },
          ],
          iconGame: true,
        },
        { desc: "鼠标加速通道", text: ["最高120hz"], star: 5 },
        { desc: "远控服务", text: ["不限"] },
        // { desc: "设备列表", text: ["100"] },
        { desc: "PC端文件传输", text: ["高速文件服务器"], star: 5 },
        { desc: "安卓被控	", text: ["1个"]},
        { desc: "共享剪贴板", check: true },
        { desc: "远程开机", check: true },
        { desc: "锁屏", check: true },
        { desc: "观看模式", check: true },
        { desc: "文字聊天", check: true },
        { desc: "音频传输", check: true },
        { desc: "锁定鼠标", check: true },
        { desc: "远程鼠标", check: true },
        { desc: "重启", check: true },
        { desc: "关机", check: true },

        { desc: "终端工具", check: true },
        { desc: "禁用被控键鼠", check: true },
        { desc: "远程摄像头", check: true },
        { desc: "隐私屏", check: true },
        { desc: "3D鼠标", check: true },
        { desc: "远程打印", check: true },
        { desc: "扩展屏和镜像屏", xmIcon: true, check: true },
        { desc: "摄像头", xmIcon: true, check: true },
        { desc: "麦克风", xmIcon: true, check: true },

        { desc: "组合按键", check: true },
        { desc: "游戏鼠标", text: ["支持Windows4.7.1及以上版本使用"] },
        { desc: "游戏键盘", text: ["支持Android、iOS端"] },
        { desc: "游戏手柄", text: ["支持在Windows使用PS、", "Xbox游戏手柄"] },

        { desc: "真彩模式", toolTip: true, content: '被控设备需支持NVIDIA独立显卡，显卡版本不够时需升级显卡驱动；被控为Mac、Linux时暂不支持开启真彩模式；v4.6.0以下版本暂不支持使用',  text: ['-'] },
        { desc: "数位板",  toolTip: true, content: '暂不支持v4.6.0以下版本或被控为Mac、Linux系统或Windows10以下系统时使用', text: ['-'] },
        { desc: "虚拟屏", toolTip: true, content: 'v4.6.0以下或win10 1903以下系统暂不支持本功能', text: ['-'] },
        { desc: "多屏", toolTip: true, content: '暂不支持被控为Linux系统时使用', text: ['-'] },
      ],
      // 专业版
      plist: [
        { desc: "网络", text: ["RTC+VIP专属高速机房通道"] },
        { desc: "画质", text: ["最高2K30FPS (超清)"], iconL: "2K@2x.png" },
        { desc: "鼠标加速通道", text: ["最高60hz"], star: 3 },
        { desc: "远控服务", text: ["不限"] },
        // { desc: "设备列表", text: ["100"] },
        { desc: "PC端文件传输", text: ["高速文件服务器"], star: 5 },
        { desc: "安卓被控	", text: ["1个"]},
        { desc: "共享剪贴板", check: true },
        { desc: "远程开机", check: true },
        { desc: "锁屏", check: true },
        { desc: "观看模式", check: true },
        { desc: "文字聊天", check: true },
        { desc: "音频传输", check: true },
        { desc: "锁定鼠标", check: true },
        { desc: "远程鼠标", check: true },
        { desc: "重启", check: true },
        { desc: "关机", check: true },

        { desc: "终端工具", check: true },
        { desc: "禁用被控键鼠", check: true },
        { desc: "远程摄像头", check: true },
        { desc: "隐私屏", check: true },
        { desc: "3D鼠标", check: true },
        { desc: "远程打印", check: true },
        { desc: "扩展屏和镜像屏", check: true },
        { desc: "摄像头", check: true },
        { desc: "麦克风", check: true },

        { desc: "组合按键", text: ["-"] },
        { desc: "游戏鼠标", text: ["-"] },
        { desc: "游戏键盘", text: ["-"] },
        { desc: "游戏手柄", text: ["-"] },

        { desc: "真彩模式", toolTip: true, content: '被控设备需支持NVIDIA独立显卡，显卡版本不够时需升级显卡驱动；被控为Mac、Linux时暂不支持开启真彩模式；v4.6.0以下版本暂不支持使用',  text: ['-'] },
        { desc: "数位板",  toolTip: true, content: '暂不支持v4.6.0以下版本或被控为Mac、Linux系统或Windows10以下系统时使用', text: ['-'] },
        { desc: "虚拟屏", toolTip: true, content: 'v4.6.0以下或win10 1903以下系统暂不支持本功能', text: ['-'] },
        { desc: "多屏", toolTip: true, content: '暂不支持被控为Linux系统时使用', text: ['-'] },
      ],
      // 个人版
      blist: [
        { desc: "网络", text: ["普通免费机房"] },
        { desc: "画质", text: ["最高1080p (高清)"] },
        { desc: "鼠标加速通道", text: ["最高20hz"], star: 1 },
        { desc: "远控服务", text: ["120h/月，300次/月"] },
        // { desc: "设备列表", text: ["100"] },
        { desc: "PC端文件传输", text: ["普通文件服务器"], star: 1 },
        { desc: "安卓被控	", text: ["0个"]},
        { desc: "共享剪贴板", check: true },
        { desc: "远程开机", check: true },
        { desc: "锁屏", check: true },
        { desc: "观看模式", check: true },
        { desc: "文字聊天", check: true },
        { desc: "音频传输", check: true },
        { desc: "锁定鼠标", check: true },
        { desc: "远程鼠标", check: true },
        { desc: "重启", check: true },
        { desc: "关机", check: true },

        { desc: "终端工具", text: ["-"] },
        { desc: "禁用被控键鼠", text: ["-"] },
        { desc: "远程摄像头", text: ["-"] },
        { desc: "隐私屏", text: ["-"] },
        { desc: "3D鼠标", text: ["-"] },
        { desc: "远程打印", text: ["-"] },
        { desc: "扩展屏和镜像屏", xmIcon: true, check: true },
        { desc: "摄像头", xmIcon: true, check: true },
        { desc: "麦克风", xmIcon: true, check: true },

        { desc: "组合按键", text: ["-"] },
        { desc: "游戏鼠标", text: ["-"] },
        { desc: "游戏键盘", text: ["-"] },
        { desc: "游戏手柄", text: ["-"] },

        { desc: "真彩模式", toolTip: true, content: '被控设备需支持NVIDIA独立显卡，显卡版本不够时需升级显卡驱动；被控为Mac、Linux时暂不支持开启真彩模式；v4.6.0以下版本暂不支持使用',  text: ['-'] },
        { desc: "数位板",  toolTip: true, content: '暂不支持v4.6.0以下版本或被控为Mac、Linux系统或Windows10以下系统时使用', text: ['-'] },
        { desc: "虚拟屏", toolTip: true, content: 'v4.6.0以下或win10 1903以下系统暂不支持本功能', text: ['-'] },
        { desc: "多屏", toolTip: true, content: '暂不支持被控为Linux系统时使用', text: ['-'] },
      ],
    };
  },
  created() {
    if (
      this.$route.query.tab &&
      [0, 1, 2, 3].indexOf(Number(this.$route.query.tab)) > -1
    ) {
      this.active_tab = this.$route.query.tab;
    }
  },
  methods: {
    close() {
      this.$router.push("/pricing_individual.html");
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.solo_cmp {
  .schead {
    width: 100%;
    height: 40px;
    background: #ffffff;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.06);
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .icon_left,
    .icon_right {
      width: 16px;
      height: 16px;
    }
    .head_text {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131314;
    }
  }
  .tab_bx {
    height: 116px;
    background: #2085ff;
    padding-top: 30px;
    padding-bottom: 60px;
    display: flex;
    box-sizing: border-box;
    .titem {
      font-size: 16px;
      flex: 0 0 25%;
      text-align: center;
      position: relative;
      color: rgba(255, 255, 255, 0.6);
      height: 32px;
      &::after {
        position: absolute;
        content: "";
        background: #2085ff;
        width: 24px;
        height: 2px;
        border-radius: 1px;
        bottom: 0;
        left: calc(50% - 9px);
      }
    }
    .titem.active {
      color: #fff;
      &::after {
        background: #fff;
      }
    }
  }
  .data_bx {
    padding-top: 20px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -30px;
    .btitle {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .dlist_items {
      padding: 10px;
      padding-bottom: 120px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      .di_item {
        height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 15px;
        padding-right: 15px;
        &.di_item2 {
          height: 60px;
        }
        &.di_item_game {
          height: 90px;
        }
        &.di_item_perform {
          .di_item_text {
            text-align: center;
          }
        }
      }
      .di_item:nth-of-type(odd) {
        background: #f7f7f7;
      }
      .di_item:nth-of-type(even) {
        background: #fff;
      }
      .di_item_title {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #383a3d;
        white-space: nowrap;
        .xmIcon {
          background: #ff470b;
          border-radius: 8px 0px;
          width: 44px;
          line-height: 20px;
          font-size: 12px;
          color: #fff;
          display: inline-block;
          text-align: center;
          margin-left: 4px;
          position: relative;
          top: -1px;
        }
      }
      .di_item_desc {
        display: flex;
        align-items: center;
        min-width: 40px;
        &.game_render {
          flex-wrap: wrap;
          justify-content: flex-end;
          .game_render_item {
            display: flex;
            align-items: center;
            &:first-of-type {
              margin-bottom: 8px;
            }
          }
        }
        .icon_left {
          width: 34px;
          height: auto;
          margin-right: 6px;
        }
        .di_item_star {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }
        .di_item_text {
          width: 100%;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0f1012;
          line-height: 22px;
          text-align: center;
        }
      }
      .di_item_check {
        width: 44px;
        height: 44px;
      }
    }
    .dboo {
      padding: 10px 20px;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      padding-bottom: 20px;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      .boo_btn {
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        border-radius: 10px;
        box-sizing: border-box;
        display: block;
        font-weight: 500;
      }
      .su_desc {
        text-align: center;
        font-size: 14px;
        margin-top: 12px;
        .t1 {
          color: #131314;
        }
        .t2 {
          color: #0070f9;
          margin-left: 8px;
        }
      }
    }
  }
  .base_bx {
    .btitle {
      color: #131314;
    }
    .dboo {
      .boo_btn {
        color: #0070f9;
        border: 1px solid #0070f9;
        line-height: 48px;
      }
    }
  }
  .pro_bx {
    .btitle {
      color: #0070f9;
    }
    .dboo {
      .boo_btn {
        color: #fff;
        background: #2085ff;
      }
    }
  }
  .game_bx {
    .btitle {
      color: #521a97;
    }
    .dboo {
      .boo_btn {
        color: #fff;
        background: #521a97;
      }
    }
    .di_item_star {
      width: 18px !important;
      height: auto !important;
    }
  }
  .perform_bx {
    .btitle {
      color: #222326;
    }
    .dboo {
      .boo_btn {
        color: #FCD4A7;
        background: #222326;
      }
    }
    .di_item_star {
      width: 18px !important;
      height: auto !important;
    }
  }
}
</style>
<style lang="less">
.el-tooltip {
  &.icon_wrap {
    margin-bottom: -2px;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 14px 14px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('~@/assets/pricing/icon_why.png');
    &:hover {
      background-image: url('~@/assets/pricing/icon_why_active.png');
    }
  }
}
.common-tool-tip {
  max-width: 355px;
  padding: 11px 16px;
  box-sizing: border-box;
  border-color: rgba(68, 69, 70, 0.95);
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  // color: rgba(38, 39, 41, 1);
  color: #fff;
  transition: none;
  &.is-dark {
    background: rgba(68, 69, 70, 0.95);
  }
  .popper__arrow {
    border-top-color: rgba(68, 69, 70, 0.95) !important;
    &::after {
      border-top-color: rgba(68, 69, 70, 0.95) !important;
    }
  }
  &.width356 {
    width: 356px;
    max-width: 356px;
  }
}
</style>
